const initModel = {
  recipients: [],
  groups: [],
  anonymouse: false,
  team: [],
  user_ids: [],
};

export default initModel;
